export default {
  title: 'Frame Selection',
  next: 'Next',
  noSelectTip:
    'Sufficient frames has been selected. No further selection allowed.',
  selected: 'Selected {selectNum}/{total}',
  submit: 'Finish',
}
